import darkDisabled from "./darkDisabled";
import darkEnabled from "./darkEnabled";
import lightDisabled from "./lightDisabled";
import lightEnabled from "./lightEnabled";

export default {
    darkEnabled,
    darkDisabled,
    lightDisabled,
    lightEnabled
}